<template>
<div style="margin:5px 0px;display:flex; justify-content:flex-end; flex-wrap: wrap;">
      <ButtonLanguages v-if="$store.getters.sondage_languages.length > 1"/>
      <ButtonTranslation
        v-if="$store.getters.sondage_languages.length > 1"
        :entitledQuestion="question.entitled"
        :entitledQuestionEn="question.entitled_en"
        :entitledQuestionEs="question.entitled_es"
        :entitledQuestionDe="question.entitled_de"
        :indexQuestion="indexQuestion"
        :indexSection="indexSection"
        :questionAnswers="question.answers"
        :sections="$store.state.question.sections"
      />
      <ElementTypeDropdown
        :questionElementType="question.element_type"
        :indexSection="indexSection"
        :indexQuestion="indexQuestion"
        :question="question"
      />
      <DuplicateQuestionButton
        :indexSection="indexSection"
        :indexQuestion="indexQuestion"
      />
      <RemoveQuestionButton
        :indexSection="indexSection"
        :indexQuestion="indexQuestion"
      />
      <DropdownBurgerQuestion
        v-if="
          elementTypeQuestion == 'radio' &&
            this.$store.state.question.sections.length
        "
        :indexQuestion="indexQuestion"
        :indexSection="indexSection"
      />
      <ButtonFoldingQuestion
        :AllFolding="AllFolding"
        :indexSection="indexSection"
        :indexQuestion="indexQuestion"
      />
  </div>
</template>

<script>
import ElementTypeDropdown from '@/components/question/components/ElementTypeDropdown'
import ButtonFoldingQuestion from '@/components/question/components/ButtonFoldingQuestion'
import ButtonLanguages from '@/components/question/components/ButtonLanguages'
import ButtonTranslation from '@/components/question/components//ButtonTranslation'
import RemoveQuestionButton from '@/components/question/components/RemoveQuestionButton'
import DuplicateQuestionButton from '@/components/question/components/DuplicateQuestionButton'
import DropdownBurgerQuestion from '@/components/question/section/dropdown/DropdownBurgerQuestion'

export default {
  name: 'ListButtonsQuestion',
  components: {
    ElementTypeDropdown,
    ButtonFoldingQuestion,
    ButtonLanguages,
    ButtonTranslation,
    RemoveQuestionButton,
    DuplicateQuestionButton,
    DropdownBurgerQuestion
  },
  props: [
    'indexQuestion',
    'indexSection',
    'elementTypeQuestion',
    'question',
    'AllFolding'
  ],
  data () {
    return {
      window: {
        width: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/components/ListButtonsQuestion.vue